<app-search></app-search>
<app-data-generator-home></app-data-generator-home>
<app-news-overview></app-news-overview>
<app-market-overview></app-market-overview>
